<template>
  <b-form @submit.stop.prevent="handleSubmit">
    <b-row>
      <b-col cols="12">
        <b-form-group
          :label="formLabels.start_date"
          label-for="compliance-document-coverage-start_date"
        >
          <sfs-date-picker
            name="compliance-document-coverage-start_date"
            v-model="$v.form.start_date.$model"
            :class="{ 'is-invalid': $v.form.start_date.$dirty && $v.form.start_date.$error }"
            :with-class="{ 'is-invalid': $v.form.start_date.$dirty && $v.form.start_date.$error }"
          />
          <b-form-invalid-feedback
            v-if="$v.form.start_date.$dirty"
            :state="$v.form.start_date.$dirty ? !$v.form.start_date.$error : null"
            class="compliance-document-coverage-start_date-feedback"
          >
            <span v-if="!$v.form.start_date.serverFailed">
              {{ serverErrors.start_date }}
            </span>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group
          :label="formLabels.end_date"
          label-for="compliance-document-coverage-end_date"
        >
          <sfs-date-picker
            name="compliance-document-coverage-end_date"
            v-model="$v.form.end_date.$model"
            :class="{ 'is-invalid': $v.form.end_date.$dirty && $v.form.end_date.$error }"
            :with-class="{ 'is-invalid': $v.form.end_date.$dirty && $v.form.end_date.$error }"
          />
          <b-form-invalid-feedback
            v-if="$v.form.end_date.$dirty"
            :state="$v.form.end_date.$dirty ? !$v.form.end_date.$error : null"
            class="compliance-document-coverage-end_date-feedback"
          >
            <span v-if="!$v.form.end_date.required">{{ formLabels.end_date_required }}</span>
            <span v-if="!$v.form.end_date.serverFailed">
              {{ serverErrors.end_date }}
            </span>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>

    <hr class="mt-4">

    <b-row>
      <b-col
        offset-lg="6"
        lg="3"
        order="2"
        order-lg="1"
      >
        <b-button
          variant="link-dark"
          block
          class="compliance-document-coverage-close-button"
          @click="$emit('on-cancel')"
        >
          Cancel
        </b-button>
      </b-col>
      <b-col
        lg="3"
        order="1"
        order-lg="2"
      >
        <b-button
          class="compliance-document-coverage-submit-button"
          block
          type="submit"
          variant="primary"
          :disabled="processing"
        >
          {{ terminology.renewCoverageButton }}
        </b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import formMixin from '@/mixins/formMixin';
import complianceDocumentTerminology from '@/utils/complianceDocumentTerminology';

export default {
  name: 'ComplianceDocumentCoveragesForm',
  mixins: [formMixin],
  props: {
    start_date: String,
    end_date: String,
    documentType: String,
  },
  data() {
    return {
      form: {
        start_date: this.start_date,
        end_date: this.end_date,
      },
    };
  },
  computed: {
    terminology() {
      return complianceDocumentTerminology(this.documentType);
    },
    formLabels() {
      return {
        start_date: this.terminology.startDateLabel,
        end_date: this.terminology.endDateLabel,
        end_date_required: this.terminology.endDateValidationText,
      };
    },
  },
  validations: {
    form: {
      start_date: {
        serverFailed() {
          return !this.hasServerErrors('start_date');
        },
      },
      end_date: {
        required,
        serverFailed() {
          return !this.hasServerErrors('end_date');
        },
      },
    },
  },
};
</script>
